import { createSelector } from 'reselect';
import {
    selectFeatureFlags,
    selectPreferences,
    selectReqHeaders,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import { isFeatureEnabled } from 'yoda-core-components/lib/helpers/Utils/Utils';

const isOrdersFromV3Impulse = (featureFlags, preferences, reqHeaders) => {
    const { getOrdersFromV3Impulse = true } = featureFlags || {};
    return isFeatureEnabled(
        { getOrdersFromV3Impulse },
        preferences,
        reqHeaders,
        // featureflag,        cookieName                   headerName
        'getOrdersFromV3Impulse',
        'DP_ORDERS_FROM_V3_IMPULSE',
        'X-ORDERS-FROM-V3-IMPULSE'
    );
};

export const selectOrdersFromV3ImpulseThrottleFF = createSelector(
    [selectFeatureFlags, selectPreferences, selectReqHeaders],
    isOrdersFromV3Impulse
);

export default { selectOrdersFromV3ImpulseThrottleFF };
